<template>
<div class="content">
  <div class="largeTitile" >供应商飞检报告</div>
  <div class="box">
    <div class="box-title">一、报告基本信息</div>
    <ul class="box-text">
      <li>飞检报告编号：{{ info.checkCode }}</li>
      <li>供应商名称：{{ info.supplierName }}</li>
      <li>飞检日期： {{ info. checkTime | dateFil }} </li>
      <li>飞检人员：{{ info.checkName }}</li>
    </ul>
  </div>

  <div class="box">
    <div class="box-title">二、供应商综合信息</div>
    <van-collapse v-model="activeNames">
      <van-collapse-item v-for="(item, index) in tabList" :title="item.label" :name="index" :key="index" class="collapse-item">
        <div v-for="(xitem,name,xindex) in item.options" :key='xindex' >
          <ul class="box-text" style="color: #323233;">
            <li>{{ xitem.label }}</li>
            <li>{{ info[xitem.value] }}</li>
          </ul>
          <!-- <div v-for="v in info[`${xitem.value}FileList`]" :key="v.supplierFlyCheckDetailId">
            <div>
              <van-image @click="showPopup"  width="100%" height="auto"  :src="v.url"/>
            </div>
          </div> -->
          <van-swipe class="my-swipe" :height="300" :stop-propagation="false">
            <van-swipe-item v-for="v in info[`${xitem.value}FileList`]" :key="v.supplierFlyCheckDetailId">
              <img v-if="['jpeg','jpg','png','webp'].includes(getFileSuffix(v.url))" class="img" v-lazy="v.url" @click="showPopup"  :src="v.url" />
              <video
                v-else-if="['mp4'].includes(getFileSuffix(v.url))" 
                :src="v.url"
                controls
                height="300"
              />
              <!-- <pdf v-else-if="['pdf'].includes(getFileSuffix(v.url))" 
                :src="v.url" 
                height="300px"
                @num-pages="pageCount = $event"
                @page-loaded="currentPage = $event"
              /> -->
              <div v-else-if="['pdf'].includes(getFileSuffix(v.url))">
              <van-swipe
                v-model="activeIndex"
                :height="300"
                :loop="false"
              >
                <van-swipe-item v-for="page in renderPageList" :key="page">
                  <pdf
                    :src="v.url"
                    :page="page"
                    @num-pages="pageCount = $event" 
                    @page-loaded="v.currentPage = $event"
                    @click="taptap(v)"
                  />
                </van-swipe-item>
              </van-swipe>
              </div>
              <div v-else> 该格式内容暂不支持手机查看，请前往后台查看！</div>
              <!-- <van-ali-video v-if="['mp4', 'mov', 'avi', 'mkv', 'webm', 'flv'].includes(v)" :source="v.url" cover="https://img.yzcdn.cn/vant/apple-1.jpg" /> -->
            </van-swipe-item>
          </van-swipe>
            
          </div>
      </van-collapse-item>
    </van-collapse>
  </div>

  <div class="box">
    <div class="box-title">三、供应商总体评价</div>
    <ul class="box-text">
      <li class="text-blod-600">优势/亮点</li>
      <li>{{ info.nice || '-' }}</li>
    </ul>

    <ul class="box-text">
      <li class="text-blod-600">风险提示</li>
      <li>{{ info.risk || '-'  }}</li>
    </ul>

    <ul class="box-text">
      <li class="text-blod-600">结论&后续改进建议</li>
      <li>{{ info.advice || '-'  }}</li>
    </ul>
  </div>


  <van-popup @click="closePop" v-model="show"  class="imgPopup">
    <v-touch @pinchin="growLarger" @pinchout="growSmall">
      {{scaleFun}}
      <!-- <div class='large_pic1'> -->
        <img  :src="picurl" alt="" :style="scaleFun" class='large_pic' >
      <!-- </div> -->
    </v-touch>
  </van-popup>
  <van-popup v-model="show1" class="imgPopup" @click="closePop1">
    <v-touch  @pinchin="growLarger" @pinchout="growSmall"  :swipe-options="{ direction: 'horizontal'}"  @swipeleft="left1(pdfList.traceabilityLabel,pdfList.subscribeTraceabilityId)" @swiperight="right1(pdfList.traceabilityLabel,pdfList.subscribeTraceabilityId)">
      <div ref="zoom" class="pdf pdfBox1" :style="scaleFun"  >
          <pdf
          :src="pdfList.fileUrl" 
          :page="pdfList.currentPage"
          @num-pages="pdfList.pageCount=$event" 
          @page-loaded="pageLoaded" 
          @loaded="pdfList.currentPage=1 "> 
          </pdf>
          <div class="footer1">{{pdfList.currentPage}}/{{pdfList.pageCount}}</div>
      </div>
    </v-touch>
  </van-popup>
</div>
</template>
<script>
import pdf from 'vue-pdf'
// import Hammer from 'hammerjs';
// import {zoomElement} from '../util/zomm'
// import pdf from 'vue-pdf-app'
// import { showImagePreview } from 'vant';

import Vue from 'vue';
import { Lazyload } from 'vant';

Vue.use(Lazyload);
// Vue.use(AliVideo);

  export default {
    components: {pdf},
    props:{
      pathurl: { type: String },
    },
    data () {
      return {
        activeIndex: 0,
        totalPage: 0,
        // currentPage: 1,
        // 仅渲染当前、上一页、下一页，防止DOM爆炸
        renderPageList: [1,2],
        tabList: [
          { 
            label: '供应商基本信息&资质', 
            options:[
              { label: '注册&信用', value: 'credit', show: [ '2']},
              { label: '资质证件', value: 'certificate', show: ['0']},
              { label: '人员信息', value: 'staff', show: ['', null,'0','1','2','3']},
              { label: '供应链', value: 'supplyChain', show: ['',null, '0','1','2','3']},
              { label: '合作意愿', value: 'cooperate', show: ['',null, '0','1','2','3']},
            ],           
          },
          { 
            label: '选址&布局', 
            options: [
              { label: '地址', value: 'address', show: [ '2']},
              { label: '外围环境', value: 'environment', show: ['0']},
            ],
          },
          { 
            label: '现场卫生', 
            options: [
              { label: '清洁情况', value: 'cleanStatus', show: [ '2']},
              { label: '防护措施', value: 'safeguard', show: ['0']},
              { label: '作业条件', value: 'workingCondition', show: ['', null,'0','1','2','3']},
              { label: '防疫与健康管理', value: 'healthControl', show: ['',null, '0','1','2','3']},
            ],
          },
          { 
            label: '仓储能力', 
            options: [
              { label: '仓库', value: 'repository', show: ['0']},
              { label: '设备', value: 'equipment', show: ['', null,'0','1','2','3']},
              { label: '库存商品', value: 'stockGoods', show: ['',null, '0','1','2','3']},
            ],
          },
          { 
            label: '供应能力', 
            options: [
              { label: '车辆', value: 'vehicle', show: [ '2']},
              { label: '产线', value: 'productionLine', show: ['0']},
              { label: '追溯能力', value: 'trace', show: ['', null,'0','1','2','3']},
            ],
          },
        ],
        activeNames: [],
        info: {}, 
        currentPage: 0, // pdf文件页码
        pageCount: 0, // pdf文件总页数 
        fileType: 'pdf', // 文件类型
        // src: "", // pdf文件地址
        src: "http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf", // pdf文件地址
        list:{},
        picurl:'',
        show:false,
        show1:false,
        pdfList:'',
        scale:1,
      }
    }, 
    async created () {
      this.src = pdf.createLoadingTask(this.src)
      const { supplierFlyCheckId = 1 } = this.$route.query
      // let arr  = date.split('')
      // arr.splice(4,0,'-')
      // arr.splice(7,0,'-')
      // this.date = arr.join('')

      const res = await this.$axios.get(`subscribe/subscribeSupplierFlyCheck/appShow?supplierFlyCheckId=${supplierFlyCheckId}`)
      const resData = res.data.data

      this.info = resData
      this.tabList.forEach(item => {
        item.options.forEach(v => {
          this.info[`${v.value}FileList`].forEach(x => {
            x.currentPage = 1
            x.pageCount = 1
          })

        })
      }) 
    } ,
    mounted() {
    },
    computed:{
      scaleFun() {
        let scale = this.scale;
        return `transform:scale(${scale})`
      }
    },
    methods: {
      getFileSuffix(url) {
        const name = url
        if (name==undefined) {
          return ''
        }
        // 找到最后一个 . 的位置
        const dotIndex = name.lastIndexOf('.')
        if (dotIndex === -1) return ''
        return name.slice(dotIndex + 1).toLowerCase()
      },
      left(name,vid) {
         let currentArr = this.list[name].find(v => v.subscribeTraceabilityId == vid)
        if(currentArr.currentPage < currentArr.pageCount ) {
          currentArr.currentPage++
        }
      },
      right(name,vid) {
        let currentArr = this.list[name].find(v => v.subscribeTraceabilityId == vid)
        if(this.currentPage > 1 ) {
          currentArr.currentPage--
        }
      },
      left1() {
        if(this.pdfList.currentPage < this.pdfList.pageCount ) {
          this.pdfList.currentPage++
        }
      },
      right1() {
        if(this.currentPage > 1 ) {
          this.pdfList.currentPage--
        }
      },
      taptap(v) {
        this.pdfList = v
        this.show1 = true
      },
      // pdf加载时
      loadPdfHandler () {
        this.currentPage = 1 // 加载的时候先加载第一页
      },
      pageLoaded(v) {
        this.currentPage = v
      },
      showPopup(e) {
        this.picurl = e.target.currentSrc
        this.show = true;
      },
      growLarger(e) {
        this.scale = e.scale
      },
      growSmall(e) {
        this.scale = e.scale
      },
      closePop() {
        this.show = false
        this.scale = 1
      },
      closePop1() {
        this.show1 = false
        this.scale = 1

      },
    }
  }

</script>
<style scoped>
.box {
  padding: 12px 0;
}
.box-title {
  padding-left: 12px;
  height: 48px;
  line-height: 48px;
  color: #fff;
  background-color: #687e97;
}
.box-text {
  padding: 12px;
  margin: 12px 0;
  line-height: 32px;
  border: solid 1px #ccc;
  border-radius: 10px;
}
.collapse-item {
  margin: 12px 0;
}
.collapse-item {
  border: solid 1px #15385e!important;
}
.van-cell__title {
  font-weight: 600!important;
}

.text-blod-600 {
  font-weight: 600;
}

.my-swipe .van-swipe-item {
    color: #fff;
    height: 500px;
    text-align: center;
    /**background-color: #39a9ed;**/
  }
  .my-swipe .van-swipe-item .img {
    width: 100%;
  }

  .footer {
    width: 40px;
    height: 15px;
    line-height: 15px;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 450px;
    right: 50px;
    border-top-left-radius:10px;
    border-top-right-radius:10px;
    border-bottom-left-radius:10px;
    border-bottom-right-radius:10px;
    color:#f6ecec;
    text-align: center;
  }
  .footer1 {
    width: 40px;
    height: 15px;
    line-height: 15px;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 400px;
    right: 50px;
    border-top-left-radius:10px;
    border-top-right-radius:10px;
    border-bottom-left-radius:10px;
    border-bottom-right-radius:10px;
    color:#f6ecec;
    text-align: center;
  }
  .pdfBox {
    position: relative;
  }
  .pdfBox1 {
    position: fixed;
    width: 300px;
    height: 500px;
    top: 20%;
    left: 15%;
  }
  .category {
    font-size: 23px;
    font-weight: 700;
    margin-right: 20px;
    color: #205792;
  }
  .name {
    font-size: 20px;
    font-weight: 500;
    color: #205792;
  }
  .titile {
  background-color: #E8EEF4;
  border-radius: 10px;
  padding: 0 10px;
  margin-top: 10px;
  margin-bottom: 15px;
  height: 70px;
  line-height: 70px;
  }
  .content {
    padding: 0 20px;
    /* margin-top: 10px; */
    background-color: #fff;
  }
  .largeTitile {
    height: 60px;
    background-color: #15385e;
    font-size: 20px;
    line-height: 60px;
    text-align: center;
    color: #fff;
    font-weight: 700;
    margin: 0 -20px;
    margin-bottom:20px ;
  }
  .large_pic {
    width: 100%;
    height: auto;
    display: block;
    /* position: fixed; */
    margin: 0 auto;
    /* top: 200px;
    left: 0; */
    /* transform:scale() */
  }
  .large_pic1 {
    text-align: center;
    margin: auto;
  }
    .imgPopup {
      width: 100%;
      height: 100%;
      background-color: #000;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
</style>